import { wechatConfig } from '../api/index'
export default {
    init(Info) {
        //微信分享所需内容
        var obj = {
            title: Info.title, // 分享标题
            desc: Info.desc, // 分享描述
            link: Info.link,//location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            //link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: Info.imgUrl, // 分享图标
        };
        var sharefun = {
            //微信分享config
            wxShare: async function (shareLink) {
                let res = await wechatConfig({ "url": shareLink })

                if (res.appid) {
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.appid,
                        timestamp: res.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.nonceStr, // 必填，生成签名的随机串
                        signature: res.signature,// 必填，签名
                        jsApiList: ['onMenuShareTimeline',
                            'onMenuShareAppMessage',
                            'onMenuShareQQ',
                            'onMenuShareWeibo',
                            'onMenuShareQZone']// 必填，需要使用的JS接口列表
                    });
                    sharefun.shareInfo(obj);
                }
            },
            shareInfo: function (obj) {
                wx.ready(function () {
                    // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareAppMessage(obj);
                    // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareTimeline(obj);

                    // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareQQ(obj);
                    // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
                    wx.onMenuShareWeibo(obj);
                    // 2.5 监听“分享到QZone”按钮点击、自定义分享内容及分享接口
                    wx.onMenuShareQZone(obj);
                })
            }
        }


        //调用微信封装 
        var shareUrl = location.href.split('#')[0];
        sharefun.wxShare(shareUrl);
    }

}
